import { useCallback, useEffect, useState } from 'react';
import { SociogramApi } from '@BUP/services/Axios';

export const useGetResponsesByPage = (user, survey, page) => {
  const enrollmentId = user?.enrollmentId;
  const surveyId = survey?.id;
  const [listState, setListState] = useState({
    isLoadingResponsesByPage: false,
    responsesByPage: [],
    errorResponsesByPage: null,
  });

  const getResponses = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoadingResponsesByPage: true,
    }));
    try {
      const { data } = await SociogramApi.get(
        `/responses?enrollmentId=${enrollmentId}&surveyId=${surveyId}&question_id.page_id=${page}`
      );
      setListState((prevState) => ({
        ...prevState,
        responsesByPage: data,
      }));
    } catch (error) {
      console.log('useGetResponsesByPage error', error);
      setListState((prevState) => ({
        ...prevState,
        errorResponsesByPage: error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoadingResponsesByPage: false,
      }));
    }
  }, [setListState, enrollmentId, surveyId, page]);

  useEffect(() => {
    if (enrollmentId && surveyId && page) getResponses();
  }, [enrollmentId, surveyId, page]);

  return {
    isLoadingResponsesByPage: listState.isLoadingResponsesByPage,
    responsesByPage: listState.responsesByPage,
    errorResponsesByPage: listState.errorResponsesByPage,
  };
};
